import React, { ReactElement, ForwardedRef } from 'react';
import MenuItemInternal from '@mui/material/MenuItem';
import CheckAccess from '../check-access/check-access.component';
import FormatService from '../../services/format-service';
import useStylesMenuItem from './menu-item.styles';

const MenuItem: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLLIElement>,
): ReactElement => {
  const {
    isActive,
    isBold,
    isInactive,
    withOffset,
    withNoWrap,
    withNoRipple,
    value,
    role,
    className,
    permission,
    onClick,
    onChange,
    onPointerDown,
    onContextMenu,
    children,
  } = props;

  const { classes } = useStylesMenuItem();

  const activeClassName: string | undefined = isActive ? classes.menuItemActive : undefined;
  const boldClassName: string | undefined = isBold ? classes.menuItemBold : undefined;
  const offsetClassName: string | undefined = withOffset ? classes.menuItemOffset : undefined;
  const noWrapClassName: string | undefined = withNoWrap ? classes.menuItemNoWrap : undefined;
  const inactiveClassName: string | undefined = isInactive ? classes.menuItemInactive : undefined;

  return (
    <CheckAccess permissions={permission ? [permission] : []}>
      <MenuItemInternal
        selected={isActive}
        disableRipple={withNoRipple}
        ref={ref}
        value={value}
        role={role}
        className={FormatService.formatClassNames(
          activeClassName, boldClassName, offsetClassName, noWrapClassName, inactiveClassName, className,
        )}
        onClick={onClick}
        onChange={onChange}
        onPointerDown={onPointerDown}
        onContextMenu={onContextMenu}
      >
        {children}
      </MenuItemInternal>
    </CheckAccess>
  );
}));

export default MenuItem;
